class Accordion {
  stateClasses = {
    open: 'accordion-item--open',
  };

  constructor($el) {
    this.$el = $el;
    this.$items = $el.find('[data-accordion="item"]');
    this.init();
  }

  init = () => {
    console.log('Accordion initialized');
    this.$items.on('click', this.handleItemClick);
  };

  handleItemClick = (e) => {
    const $item = $(e.currentTarget);

    if ($item.hasClass(this.stateClasses.open)) {
      this.closeItem($item);
    } else {
      this.closeAllItems();
      this.openItem($item);
    }
  };

  openItem = ($item) => {
    if ($item.hasClass(this.stateClasses.open)) return;

    const $content = $item.find('[data-accordion="content"]');
    $item.addClass(this.stateClasses.open);

    // Temporär max-height auf "0px" setzen, um Transition zu erzwingen
    $content.css('max-height', '0px');

    // Warten, bis der Browser den neuen Style registriert
    requestAnimationFrame(() => {
      const scrollHeight = $content.prop('scrollHeight');
      $content.css('max-height', `${scrollHeight}px`);
    });

    // Nach der Animation max-height entfernen
    $content.one('transitionend', () => {
      if ($item.hasClass(this.stateClasses.open)) {
        $content.css('max-height', 'none');
      }
    });
  };

  closeItem = ($item) => {
    if (!$item.hasClass(this.stateClasses.open)) return;

    const $content = $item.find('[data-accordion="content"]');
    const scrollHeight = $content.prop('scrollHeight');

    $item.removeClass(this.stateClasses.open);

    // Setze max-height auf die aktuelle Höhe, um die Animation zu starten
    $content.css('max-height', `${scrollHeight}px`);

    // Dann auf "0px" setzen, um das Schließen zu animieren
    requestAnimationFrame(() => {
      $content.css('max-height', '0px');
    });
  };

  closeAllItems = () => {
    this.$items.each((_, el) => this.closeItem($(el)));
  };
}

export default Accordion;
